import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SharedChatState} from "@shared/components/chat/store/shared-chat.state";

export const sharedChatStoreSelect = createFeatureSelector<SharedChatState>('sharedChat');

export const selectSharedChatStore = createSelector(
  sharedChatStoreSelect,
  (state: SharedChatState) => state
);

export const selectSharedChatItems = createSelector(
  sharedChatStoreSelect,
  (state: SharedChatState) => state.items
);

export const selectSharedChatLastFetchedMessageId = createSelector(
  sharedChatStoreSelect,
  (state: SharedChatState) => state.lastFetchedMessageId
);

export const selectSharedChatLoading = createSelector(
  sharedChatStoreSelect,
  (state: SharedChatState) => state.isLoading
);

export const selectIsAccessDenied = createSelector(
  sharedChatStoreSelect,
  (state: SharedChatState) => state.isAccessDenied
);
